/** True when a JWT's `exp` is in the past. Unparseable or exp-less tokens are NOT treated as expired. */
export function isJwtExpired(token: string | null | undefined, nowMs: number = Date.now()): boolean {
  if (!token) return false;
  try {
    const payload = token.replace(/^Bearer\s+/i, '').split('.')[1];
    if (!payload) return false;
    const json = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return typeof json.exp === 'number' && json.exp * 1000 <= nowMs;
  } catch {
    return false;
  }
}
